"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var core_1 = require("@angular/core");
var utilities_1 = require("./utilities");
var tooltip_1 = require("./tooltip");
/**
 * @deprecated - use BaseSettings from ng-controls
 */
var SisSimpleSettings = /** @class */ (function (_super) {
    __extends(SisSimpleSettings, _super);
    function SisSimpleSettings(_communicationService) {
        var _this = _super.call(this, _communicationService) || this;
        _this._communicationService = _communicationService;
        return _this;
    }
    SisSimpleSettings.prototype.hintChange = function (hint) {
        this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            bindings: {},
            state: { hint: utilities_1.multilingualToString(hint) },
        }));
    };
    Object.defineProperty(SisSimpleSettings.prototype, "state", {
        set: function (value) {
            if (value['hint'] !== '') {
                this.hint = utilities_1.stringToMultilingual(value['hint']);
            }
            if (value['tooltipSettings']) {
                this._tooltipSettings = tooltip_1.TooltipSettings.fromJsonString(value['tooltipSettings']);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisSimpleSettings.prototype, "controlLabel", {
        get: function () {
            return this._controlLabel;
        },
        set: function (controlLabel) {
            this._controlLabel = controlLabel;
            this._communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                controlLabel: controlLabel
            }));
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisSimpleSettings.prototype, "languages", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisSimpleSettings.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [idm_crosscutting_concepts_frontend_1.MultilingualString]),
        __metadata("design:returntype", void 0)
    ], SisSimpleSettings.prototype, "hintChange", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisSimpleSettings.prototype, "state", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisSimpleSettings.prototype, "controlLabel", null);
    return SisSimpleSettings;
}(tooltip_1.SisControlWithTooltipSettings));
exports.SisSimpleSettings = SisSimpleSettings;
//# sourceMappingURL=sis-simple-settings.js.map